// src/auth/ProtectedRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { isAuthed } from "./sessionAuth";

export default function ProtectedRoute() {
  if (!isAuthed()) return <Navigate to="/login" replace />;
  return <Outlet />;
}
